export default __webpack_public_path__ + "static/media/pic3.1c380ea3.jpg";